import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Compliance footer the backend auto-appends; shown in previews. */
export var SMS_COMPLIANCE_FOOTER = "Reply STOP to opt out. Msg & data rates may apply.";

/** Tokens an SMS body may contain (resolved server-side at send time). */
export var SMS_BODY_TOKENS = ["@fname", "@shortlink"];
var SEGMENT_LENGTH = 160;
var SAMPLE_SHORT_LINK_TOKEN = "aXbYcZdWeVfUgThSiRjQkP";
var SAMPLE_TOKEN_VALUES = {
  "@fname": "Sarah",
  "@lname": "Jones",
  "@fullname": "Sarah Jones",
  "@dob": "05/22/1965",
  "@facility": "your care team"
};

/** Number of 160-char SMS segments the given text spans (minimum one). */
export function countSegments(text) {
  var _text$length;
  return Math.max(1, Math.ceil(((_text$length = text === null || text === void 0 ? void 0 : text.length) !== null && _text$length !== void 0 ? _text$length : 0) / SEGMENT_LENGTH));
}

/** True when the template body contains the @shortlink token. */
export function hasShortLink(body) {
  return /@shortlink\b/.test(body || "");
}

/** Ordered, de-duplicated list of @token variables present in a template body. */
export function extractTokens(body) {
  var _match;
  var matches = (_match = (body || "").match(/@\w+/g)) !== null && _match !== void 0 ? _match : [];
  return Array.from(new Set(matches));
}

/** Resolves display tokens in a template body using sample or provided values. */
export function resolveTokens(body) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var origin = typeof window !== "undefined" ? window.location.origin : "";
  var values = _objectSpread(_objectSpread({}, SAMPLE_TOKEN_VALUES), {}, {
    "@shortlink": "".concat(origin, "/s/").concat(SAMPLE_SHORT_LINK_TOKEN)
  }, overrides);
  var out = body || "";
  Object.keys(values).forEach(function (token) {
    out = out.split(token).join(values[token]);
  });
  return out;
}

/** Builds the preview text (resolved body + auto footer) and its segment count. */
export function buildPreview(body) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resolved = resolveTokens(body, overrides).trim();
  var normalized = resolved.replace(/\s+/g, " ");
  var hasFooter = normalized.includes(SMS_COMPLIANCE_FOOTER);
  var withFooter = hasFooter ? resolved : "".concat(resolved, " ").concat(SMS_COMPLIANCE_FOOTER).trim();
  return {
    text: withFooter,
    segments: countSegments(withFooter)
  };
}

/** A template is usable at send time when it is active and has the secure link. */
export function isTemplateSendable(template) {
  return Boolean(template.active) && hasShortLink(template.body);
}